import { useEffect, useRef } from 'react';

/**
 * Debounce route rebuilds when inputs change.
 */
export function useAutoBuild({
	autoBuildPending,
	setAutoBuildPending,
	loading,
	canBuild,
	handleBuildRoute,
	isIndoor,
}) {
	const latestBuildRef = useRef(handleBuildRoute);

	useEffect(() => {
		latestBuildRef.current = handleBuildRoute;
	}, [handleBuildRoute]);

	useEffect(() => {
		if (!autoBuildPending) return;
		if (loading) return;
		if (!canBuild) return;
		const timer = setTimeout(
			() => {
				(async () => {
					try {
						await latestBuildRef.current?.();
					} finally {
						setAutoBuildPending(false);
					}
				})();
			},
			isIndoor ? 150 : 450
		);
		return () => clearTimeout(timer);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [autoBuildPending, canBuild, loading, isIndoor, setAutoBuildPending]);

	useEffect(() => {
		if (autoBuildPending && !canBuild && !loading) {
			setAutoBuildPending(false);
		}
	}, [autoBuildPending, canBuild, loading, setAutoBuildPending]);
}
